var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body",class:{'has-fixed-header': _vm.fixedHeader}},[(_vm.sortable)?_c('draggable',{model:{value:(_vm.sorted),callback:function ($$v) {_vm.sorted=$$v},expression:"sorted"}},[_vm._t("default")],2):_vm._e(),(!_vm.sortable)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }